/**
 * GridLayout — DndContext + SortableContext envolvendo a grid de widgets.
 *
 * dnd-kit `SortableContext` com strategy `rectSortingStrategy` (apropriado
 * pra grid 2D, ao contrario de verticalListSortingStrategy). Em modo
 * leitura, drag-and-drop fica disabled (cada WidgetCard checa `modoEdicao`).
 */
import React from "react";
import {
  DndContext,
  PointerSensor,
  KeyboardSensor,
  closestCenter,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  rectSortingStrategy,
  sortableKeyboardCoordinates,
} from "@dnd-kit/sortable";

import WidgetCard from "./WidgetCard";

import { Grid, WidgetSlot, VazioMsg } from "./styles";


export default function GridLayout({
  widgetsAtivos,
  contexto,
  dados,
  loading,
  error,
  modoEdicao,
  onReordenar,
  onRemover,
}) {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 6 },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  if (!widgetsAtivos || widgetsAtivos.length === 0) {
    return (
      <VazioMsg>
        Nenhum widget ativo. Clique em <strong>Personalizar</strong> no topo
        para adicionar.
      </VazioMsg>
    );
  }

  const ids = widgetsAtivos.map((w) => w.id);

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    const oldIndex = ids.indexOf(active.id);
    const newIndex = ids.indexOf(over.id);
    if (oldIndex === -1 || newIndex === -1) return;
    const novaOrdem = [...ids];
    novaOrdem.splice(oldIndex, 1);
    novaOrdem.splice(newIndex, 0, active.id);
    onReordenar(novaOrdem);
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext items={ids} strategy={rectSortingStrategy}>
        <Grid>
          {widgetsAtivos.map((w) => (
            <WidgetSlot key={w.id} $tamanho={w.tamanho}>
              <WidgetCard
                widget={w}
                contexto={contexto}
                dados={dados[w.id]}
                loading={Boolean(loading[w.id])}
                error={error[w.id]}
                modoEdicao={modoEdicao}
                onRemover={onRemover}
              />
            </WidgetSlot>
          ))}
        </Grid>
      </SortableContext>
    </DndContext>
  );
}
